module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-[114]479.104ec6e.woff2";